import { render, staticRenderFns } from "./Reason.vue?vue&type=template&id=f84dc1e0&scoped=true&"
import script from "./Reason.vue?vue&type=script&lang=js&"
export * from "./Reason.vue?vue&type=script&lang=js&"
import style0 from "./Reason.vue?vue&type=style&index=0&id=f84dc1e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84dc1e0",
  null
  
)

export default component.exports